import React,{useState} from "react";


import createIcon from "../components/icons/add_circle_FILL0_wght200_GRAD0_opsz40.svg";

import profileIcon from "../components/icons/person_add_FILL0_wght200_GRAD0_opsz40.svg";
import myEnrollmentsIcon from "../components/icons/store_FILL0_wght200_GRAD0_opsz40.svg";
import myDashboard from "../components/icons/castle_FILL0_wght200_GRAD-25_opsz40.svg";
import myWishlist from "../components/icons/add_a_photo_FILL0_wght200_GRAD0_opsz40.svg";
import Logout from "../components/Logout";

import { useDispatch } from 'react-redux';
import { useSelector } from "react-redux";
   
// import { useSelector } from "react-redux";

import {Link } from "react-router-dom";

import LoadingCards from "../components/Loading/LoadingCards";

import loadable from '@loadable/component';
const ArrCards= [1,2,3,4,5,6,];
let lazyLoad =   <LoadingCards cards={ArrCards} type="ExtraSmallCard"/>;
const CardNav = loadable(() => import("../components/UI/CardNav"), {
    fallback: lazyLoad  });
    const CardNavTwo = loadable(() => import("../components/UI/CardNavTwo"), {
      fallback: lazyLoad  });
      const CardNavTwoTop = loadable(() => import("../components/UI/CardNavTwoTop"), {
        fallback: lazyLoad  });
      const courseNav=[{
        id:'1',
        title:"Payments",
        alt:"Accept and manage payments right from your dashboard with ClassMock`s Integrated Payments Gateway & Get Money Right Into Your Bank Account",
        link:"/pages/?filter=Trending",
        icon:0,
        
      },{ id:'3',
        title:"Contacts CRM, Zapier , Pably , Pixel ",
        alt:"Move your audience off social media and own your relationship with them.",
        link:"/pages/?payment=Paid",
        icon:2,
      },{ id:'2',
        title:"Analytics & Performance",
        alt:"Use the right metrics, organized into reports you’ll actually use.",
        link:"/pages/?payment=Free",
        icon:1,
        
      }]
      const courseNavFive=[{
        id:'1',
        title:"Class 1 to 12 Tuitions",
        alt:"Manage Your Offline Tuitions Batches , Give Your Students An Elevated Learning Experience With Your Own App",
        link:"/pages/?filter=Trending",
        icon:0,
        
      },{ id:'2',
        title:"BA/ BSC/ BCOM/ BTech ",
        alt:"Teach Your College Students With An UnConventional Approach And Lets Join The Change In Learning Technologies",
        link:"/pages/?payment=Free",
        icon:1,
        
      },{ id:'3',
        title:"UPSC /State PSC",
        alt:"If You Own A Coaching Institute,Manage It Well With Our Coaching Management Suite,Or Go Online Beyond Scope of Your Institute",
        link:"/pages/?payment=Paid",
        icon:2,
      },{ id:'4',
        title:"JEE/ NEET",
        alt:"Manage  Coaching Institute Well With Our Coaching Management Suite,Or Go Online Beyond Scope of Your Institute" ,
          link:"/pages/?payment=Paid",
        icon:4,
      },{ id:'5',
        title:"Teaching Entrance Exams",
        alt:"Manage  Coaching Institute Well With Our Coaching Management Suite,Or Go Online Beyond Scope of Your Institute",
        link:"/pages/?payment=Paid",
        icon:5,
      },{ id:'6',
        title:"GATE / IES-ESE ",
        alt:"Manage  Coaching Institute Well With Our Coaching Management Suite,Or Go Online Beyond Scope of Your Institute",
        link:"/pages/?payment=Paid",
        icon:6,
      },{ id:'7',
        title:"CAT / GMAT",
        alt:"Manage  Coaching Institute Well With Our Coaching Management Suite,Or Go Online Beyond Scope of Your Institute",
        link:"/pages/?payment=Paid",
        icon:7,
      },{ id:'8',
        title:"Banking Exams",
        alt:"Manage  Coaching Institute Well With Our Coaching Management Suite,Or Go Online Beyond Scope of Your Institute",
        link:"/pages/?payment=Paid",
        icon:8,
      },{ id:'9',
        title:"CA / Law / CLAT ",
        alt:"Manage  Coaching Institute Well With Our Coaching Management Suite,Or Go Online Beyond Scope of Your Institute",
        link:"/pages/?payment=Paid",
        icon:9,
      }]

       const courseNavSix=[{
        id:'1',
        title:"AI Course Creator",
        alt:"Manage Your Offline Tuitions Batches , Give Your Students An Elevated Learning Experience With Your Own App",
        link:"/pages/?filter=Trending",
        icon:0,
        
      },{ id:'2',
        title:"AI Test Series Builder",
        alt:"Teach Your College Students With An UnConventional Approach And Lets Join The Change In Learning Technologies",
        link:"/pages/?payment=Free",
        icon:1,
        
      },{ id:'3',
        title:"AI Website Creator",
        alt:"If You Own A Coaching Institute,Manage It Well With Our Coaching Management Suite,Or Go Online Beyond Scope of Your Institute",
        link:"/pages/?payment=Paid",
        icon:2,
      },{ id:'4',
        title:"AI Funnel  ",
        alt:"Manage  Coaching Institute Well With Our Coaching Management Suite,Or Go Online Beyond Scope of Your Institute" ,
          link:"/pages/?payment=Paid",
        icon:4,
      }
      // ,{ id:'5',
      //   title:"Teaching Entrance Exams",
      //   alt:"Manage  Coaching Institute Well With Our Coaching Management Suite,Or Go Online Beyond Scope of Your Institute",
      //   link:"/pages/?payment=Paid",
      //   icon:5,
      // }
      // ,{ id:'6',
      //   title:"GATE / IES-ESE ",
      //   alt:"Manage  Coaching Institute Well With Our Coaching Management Suite,Or Go Online Beyond Scope of Your Institute",
      //   link:"/pages/?payment=Paid",
      //   icon:6,
      // },{ id:'7',
      //   title:"CAT / GMAT",
      //   alt:"Manage  Coaching Institute Well With Our Coaching Management Suite,Or Go Online Beyond Scope of Your Institute",
      //   link:"/pages/?payment=Paid",
      //   icon:7,
      // },{ id:'8',
      //   title:"Banking Exams",
      //   alt:"Manage  Coaching Institute Well With Our Coaching Management Suite,Or Go Online Beyond Scope of Your Institute",
      //   link:"/pages/?payment=Paid",
      //   icon:8,
      // },{ id:'9',
      //   title:"CA / Law / CLAT ",
      //   alt:"Manage  Coaching Institute Well With Our Coaching Management Suite,Or Go Online Beyond Scope of Your Institute",
      //   link:"/pages/?payment=Paid",
      //   icon:9,
      // }
    
    ]
const Navber=()=>{

    const dispatch = useDispatch();
    
    const handleMouseEnter = () =>dispatch({
      type: "CURSOR",
      
      payload:true
    });
    const handleMouseLeave = () => dispatch({
      type: "CURSOR",
      
      payload:false
    });
 const [statusLoading , setStatusLoading] = useState({status:true});
    const localToken= localStorage.getItem("profile")
    const token = useSelector((state)=>state?.user?.user?.token);
  
    const mainMenuStatus = useSelector((state)=>state?.app?.mainMenuStatus);
setTimeout(()=>{setStatusLoading({status:false})},1000)
     const userdata = useSelector((state)=>state?.user?.user);
    return (<>

  

<div className="fix-menu-theme bgGradient1" style={{display:"grid",gridTemplateColumns:"100%"}}>
{statusLoading.status?<LoadingCards cards={ArrCards} type="ExtraSmallCard" />:(token)?<>
    {/* <Link   to="/dashboard/profile">
    <CardNav  icon={profileIcon} alt="User" title={userdata?.first_name?("Hey "+userdata?.first_name+" !!! "):"Hey User !!!"}  >
</CardNav>
</Link>  */}


{mainMenuStatus?<div >
<CardNavTwoTop  icon={0} alt="ShowMenu" title=""  >

</CardNavTwoTop>
  </div>:<div >
<CardNavTwoTop  icon={7} alt="Hide Menu" title="Hide Menu"  >

</CardNavTwoTop>
  </div>}

  


  {/* <CardNavTwo   link={`/apps/dashboard`} icon={8} alt="" title="Dashboard "  >

</CardNavTwo> */}


<CardNavTwo link={`/apps`}  icon={2}  alt="My Apps" title="My Apps"  >

</CardNavTwo>

{/* <CardNavTwo   link ={`/apps/analytics`} icon={5} alt="Analytics" title="AI Features"  >

</CardNavTwo> */}

<CardNavTwo link ={`/apps/manage-payments`} icon={3} alt="Manage Payments" title="Payments"  >

</CardNavTwo>
<Link to={`/apps/courses`}>
<CardNavTwo   link={`/apps/courses`} icon={6} alt="Create Courses " title="Settings "  >

</CardNavTwo>
</Link>

{/* <CardNavTwo   link={`/apps/website`} icon={1} alt="Create Website, App , Courses & User" title="Create  With AI "  >

</CardNavTwo> */}
    {/* <CardNavTwo link ={`/apps/profile`}  icon={4} alt="Chats" title="Chats" >
</CardNavTwo>

<CardNavTwo  link ={`/dashboard/profile/user-details`}  icon={6} alt="settings" title="Creator Studio"  >

</CardNavTwo> */}



{/* 
<Logout/> */}
</>:<> <CardNav  icon={profileIcon} alt="User" title={"Hey User !!!"}  >
</CardNav>


<Link    to="/login">
<CardNav  icon={createIcon} alt="Login" title="Login"  >

</CardNav>

</Link>
<Link    to="/signup">
<CardNav  icon={createIcon} alt="Profile Icon" title="Signup"  >

</CardNav>

</Link>

</>}

</div>

</>)
}
export default Navber;